// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/email.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/padlock 1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/person.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  max-width: 100%;
  overflow-x: hidden;
}

.inputField {
  border: none !important;
  border-bottom: 1px solid #000000 !important;
  /* Optional: Add a bottom border for a cleaner look */
  border-radius: 0 !important;
  /* Remove border-radius if applied by default */
  box-shadow: none !important;
  /* Remove any box shadow */
}



.page-container {
  display: flex;
  height: 100vh;
  width: 87vw;
}

.half-container {
  flex: 1 1;
  width: 100%;
  /* padding: 20px; */
  /* border: 1px solid #ddd; */
  box-sizing: border-box;
}


.left {
  margin-top: 5vw;
  margin-left: 14vw;
}

.icone {
  margin-top: 1vw;
  height: 1vw;
  margin-right: 1vw;

}

.cardl {
  width: 35vw;
}

.custom-placeholder-color::placeholder {
  color: #333 !important;
  /* Set the color of the placeholder */
}

.reg {
  /* border-color: #000000; */
  width: 35vw;
  /* border-style: solid; */
  border-radius: 2vw;
  background-color: blue;
  /* background-color: #000842; */
  color: white;
  height: 3vw;
}

.right {
  margin-top: 0.8vw;
  height: 97%;
  width: 117%;
  /* background-color: rgb(32, 32, 156); */
  background-color: #000842;
  border-radius: 0.5vw;
  margin-left: 6vw;
}

.tv {
  height: 100%;
  width: 150%;
  margin-left: -10vw;
}

input[type=email] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}

input[type=password] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}
input[placeholder="First Name"] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}
input[placeholder="Last Name"] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}



@media (max-width: 768px) {
  .half-container {
    flex: 1 1;
    width: 100%;
    /* border-color: #000000;
    border-style: solid;
    border-width: 1vw; */
  }

  .page-container {
    display: block;
    height: 100vh;
    width: 87vw;
  }

  .cardl {
    width: 73vw;
  }

  .reg {
    height: 7vw;
    border-radius: 8%;
  }

  .ln::placeholder,
  .fn::placeholder {
    text-indent: 5vw;
  }

  input[type=checkbox] {
    margin-right: 0.4vw;
    height: 10vw;
    font-size: xx-large;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/signup.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,qDAAqD;EACrD,2BAA2B;EAC3B,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;AAC5B;;;;AAIA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yDAA4C;EAC5C,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yDAAiD;EACjD,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yDAA6C;EAC7C,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yDAA6C;EAC7C,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;;;AAIA;EACE;IACE,SAAO;IACP,WAAW;IACX;;wBAEoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;AAEF","sourcesContent":["html,\r\nbody {\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.inputField {\r\n  border: none !important;\r\n  border-bottom: 1px solid #000000 !important;\r\n  /* Optional: Add a bottom border for a cleaner look */\r\n  border-radius: 0 !important;\r\n  /* Remove border-radius if applied by default */\r\n  box-shadow: none !important;\r\n  /* Remove any box shadow */\r\n}\r\n\r\n\r\n\r\n.page-container {\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 87vw;\r\n}\r\n\r\n.half-container {\r\n  flex: 1;\r\n  width: 100%;\r\n  /* padding: 20px; */\r\n  /* border: 1px solid #ddd; */\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n.left {\r\n  margin-top: 5vw;\r\n  margin-left: 14vw;\r\n}\r\n\r\n.icone {\r\n  margin-top: 1vw;\r\n  height: 1vw;\r\n  margin-right: 1vw;\r\n\r\n}\r\n\r\n.cardl {\r\n  width: 35vw;\r\n}\r\n\r\n.custom-placeholder-color::placeholder {\r\n  color: #333 !important;\r\n  /* Set the color of the placeholder */\r\n}\r\n\r\n.reg {\r\n  /* border-color: #000000; */\r\n  width: 35vw;\r\n  /* border-style: solid; */\r\n  border-radius: 2vw;\r\n  background-color: blue;\r\n  /* background-color: #000842; */\r\n  color: white;\r\n  height: 3vw;\r\n}\r\n\r\n.right {\r\n  margin-top: 0.8vw;\r\n  height: 97%;\r\n  width: 117%;\r\n  /* background-color: rgb(32, 32, 156); */\r\n  background-color: #000842;\r\n  border-radius: 0.5vw;\r\n  margin-left: 6vw;\r\n}\r\n\r\n.tv {\r\n  height: 100%;\r\n  width: 150%;\r\n  margin-left: -10vw;\r\n}\r\n\r\ninput[type=email] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: white;\r\n  background-image: url('../assets/email.svg');\r\n  background-position: 10px 10px;\r\n  background-repeat: no-repeat;\r\n  padding: 12px 20px 12px 40px;\r\n}\r\n\r\ninput[type=password] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: white;\r\n  background-image: url('../assets/padlock\\ 1.svg');\r\n  background-position: 10px 10px;\r\n  background-repeat: no-repeat;\r\n  padding: 12px 20px 12px 40px;\r\n}\r\ninput[placeholder=\"First Name\"] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: white;\r\n  background-image: url('../assets/person.svg');\r\n  background-position: 10px 10px;\r\n  background-repeat: no-repeat;\r\n  padding: 12px 20px 12px 40px;\r\n}\r\ninput[placeholder=\"Last Name\"] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: white;\r\n  background-image: url('../assets/person.svg');\r\n  background-position: 10px 10px;\r\n  background-repeat: no-repeat;\r\n  padding: 12px 20px 12px 40px;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .half-container {\r\n    flex: 1;\r\n    width: 100%;\r\n    /* border-color: #000000;\r\n    border-style: solid;\r\n    border-width: 1vw; */\r\n  }\r\n\r\n  .page-container {\r\n    display: block;\r\n    height: 100vh;\r\n    width: 87vw;\r\n  }\r\n\r\n  .cardl {\r\n    width: 73vw;\r\n  }\r\n\r\n  .reg {\r\n    height: 7vw;\r\n    border-radius: 8%;\r\n  }\r\n\r\n  .ln::placeholder,\r\n  .fn::placeholder {\r\n    text-indent: 5vw;\r\n  }\r\n\r\n  input[type=checkbox] {\r\n    margin-right: 0.4vw;\r\n    height: 10vw;\r\n    font-size: xx-large;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
